import type { PlatformServices } from '../types';
import { createWebApp } from './app';
import { createWebBrowser } from './browser';
import { createWebHaptics } from './haptics';
import { createWebLifecycle } from './lifecycle';
import { createMusic } from './music';
import { audioState, preferAmbientAudio, setAudioSuspended } from './audioContext';
import { createSynthSfx } from './synthAudio';
import { createWebShare } from './share';
import { createWebUpdates } from './updates';

/** Web adapters; with platform/native/index.ts, one of the two is aliased to @/platform/impl per build. */
export function createPlatform(): PlatformServices {
  preferAmbientAudio();
  return {
    kind: 'web',
    app: createWebApp(),
    lifecycle: createWebLifecycle(),
    haptics: createWebHaptics(),
    browser: createWebBrowser(),
    share: createWebShare(),
    sfx: createSynthSfx(),
    music: createMusic(),
    audio: { setSuspended: setAudioSuspended, state: audioState },
    updates: createWebUpdates(),
  };
}
